import { SxStyles } from '../../types';

export const ControlPanelFooterSX: SxStyles = {
  footerSx: {
    m: '0 1em',
    ml: '25px',
    pr: '10px',
    '& .content ': {
      '& .client-preview': {
        height: '100%',
        '& .player-container': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          maxWidth: 'unset',
          minHeight: 'unset',
          height: '100%',
          right: 'unset',
          p: 0,
          '& .player-overlay': {
            pt: '42.92%',
            right: 0,
            top: 0,
            '& .react-player': {
              position: 'absolute',
              top: 0,
              minHeight: 'unset',
              p: 1,
              '& iframe, video': {
                borderRadius: '0 0 20px 20px',
              },
            },
          },
          '& .player-overlay-image': {
            position: 'relative',
            width: '50%',
            display: 'flex',
            margin: 'auto',
            height: '100%',
            justifyContent: 'center',
            '&::before': {
              content: '""',
              display: 'block',
              paddingTop: '56.25%',
            },
            '& img': {
              position: 'absolute',
              alignSelf: 'center',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            },
          },
        },
        '& .player-container-image': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          maxWidth: 'unset',
          minHeight: 'unset',
          height: '100%',
          right: 'unset',
          p: 0,
        },
      },
    },
  },
};
